export const classes = {
  wrapper: 'mb-8 px-6 flex items-start justify-between',
  titleWrapper: 'grow',
  subtitle: 'font-normal text-sm text-grey-6',
  buttonsWrapper: 'flex justify-end items-center px-6 h-12',
  searchButton: 'ml-4 px-4 py-0 text-sm max-w-[300px]',
  addButton: 'py-1 ml-4',
  buttonText: 'ml-2',
};
